// extracted by mini-css-extract-plugin
module.exports = {"emoji":"emoji_emoji__1iiSL"};